export default {"src":"/_next/static/media/clock.910d7c93.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};